import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadApiConfig } from "./libs/http/http";
import config from "./config";
import rules from "./validations";
import vueDebounce from "vue-debounce";
import VueMask, { VueMaskDirective } from "v-mask";
import VueMarkdownEditor from "@kangc/v-md-editor";
import "@kangc/v-md-editor/lib/style/base-editor.css";
import vuepressTheme from "@kangc/v-md-editor/lib/theme/vuepress.js";
import "@kangc/v-md-editor/lib/theme/style/vuepress.css";
import enUS from "@kangc/v-md-editor/lib/lang/en-US";
import "@mdi/font/css/materialdesignicons.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
// The app's single stylesheet: imported after the libraries' CSS so it can refine them.
import "./styles/main.scss";
import VueGeolocation from "vue-browser-geolocation";
import Prism from "prismjs";
import "prismjs/components/prism-json";
import Select2 from "v-select2-component";

Vue.config.productionTip = false;

// Third-party plugins (registered globally, as before).
Vue.use(VueGeolocation);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

VueMarkdownEditor.lang.use("en-US", enUS);
VueMarkdownEditor.use(vuepressTheme, { Prism });
Vue.use(VueMarkdownEditor);

Vue.use(VueMask);
Vue.directive("mask", VueMaskDirective);
Vue.use(vueDebounce);
Vue.component("Select2", Select2);

// App-wide helpers available in every template.
Vue.prototype.$config = config;
Vue.prototype.$rules = rules;

// Mount only after the API address is known, so no request goes out with an empty baseURL.
loadApiConfig().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
